@if (editType() !== EditType.DELETE) {
  <form (ngSubmit)="onSubmit(modalComponent())" class="p-3">
    <div class="mb-3 row">
      <label for="startDate" class="col-sm-4 col-form-label">Start date</label>
      <div class="col-sm-8">
        <input id="startDate" type="text" class="form-control-plaintext" [formField]="timeOffForm.startDate">
      </div>
    </div>
    <div class="mb-3 row">
      <label for="dayOfWeek" class="col-sm-4 col-form-label">Every</label>
      <div class="col-sm-8">
        <select class="form-control"
                id="dayOfWeek"
                [formField]="timeOffForm.dayOfWeek">
          @for (weekday of weekdays; track weekday) {
            <option [ngValue]="weekday"
                    [disabled]="dayOfWeekExists(weekday)">{{ weekday | enumParse }}
            </option>
          }
        </select>
      </div>
    </div>
    <app-time-off-form-common-fields
            [fields]="timeOffForm.commonFields"
            [storeWorkingTime]="storeWorkingTime()">
    </app-time-off-form-common-fields>
    <div class="mt-4 text-end">
      <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
              (click)="modalComponent().activeModal.close()">Close
      </button>
      <button
              class="btn btn-primary btn-form save-button"
              type="submit"
              [disabled]="timeOffForm().invalid() || loading()">Save
      </button>
    </div>
  </form>
}
@if (editType() === EditType.DELETE) {
  <div>
    <div class="confirmation-text">
      Do you really want to delete preferred time off for {{ dayOfWeek() | enumParse }}
      starting from {{ startDate() }}?
    </div>
    <div class="mt-4 text-end">
      <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
              (click)="modalComponent().activeModal.close()">Close
      </button>
      <button class="btn btn-danger btn-form" type="button" (click)="onSubmit(modalComponent())" [disabled]="loading()">
        Delete
      </button>
    </div>
  </div>
}